"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _cookie2 = require("@micado-digital/react-ui/utils/cookie");

var _log = _interopRequireDefault(require("@micado-digital/react-ui/utils/log"));

var _executeCode = _interopRequireDefault(require("../utils/executeCode"));

var _getCodesByID = _interopRequireDefault(require("../utils/getCodesByID"));

var _removeCode = _interopRequireDefault(require("../utils/removeCode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ReactTracking = function ReactTracking(_ref) {
  var _ref$codes = _ref.codes,
      codes = _ref$codes === void 0 ? [] : _ref$codes;

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation.pathname,
      search = _useLocation.search;

  var url = "".concat(pathname).concat(search);
  var blackList = ["google-analytics", "google-analytics-v3", "google-analytics-v4", "google-tag-manager", "google-tag-manager-body"];
  (0, _react.useEffect)(function () {
    sessionStorage.removeItem("mw-tracking-codes");
    sessionStorage.setItem("mw-tracking-blacklist", blackList);
    sessionStorage.setItem("mw-tracking-mode", "react"); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    var _trackingCodes2, _trackingCodes2$split;

    // Check if consent is accepted
    var cookie = (0, _cookie2.getCookie)("mw-cookie-settings");
    if (!cookie) return; // Get loaded tracking codes from session storage

    var _trackingCodes = sessionStorage.getItem("mw-tracking-codes");

    _trackingCodes = _trackingCodes ? (_trackingCodes2 = _trackingCodes) === null || _trackingCodes2 === void 0 ? void 0 : (_trackingCodes2$split = _trackingCodes2.split(",")) === null || _trackingCodes2$split === void 0 ? void 0 : _trackingCodes2$split.map(function (item) {
      return parseInt(item);
    }) : []; // Parse consent cookie and execute or remove code

    var _ref2 = JSON.parse(cookie) || {},
        _ref2$list = _ref2.list,
        cookieList = _ref2$list === void 0 ? [] : _ref2$list;

    var _iterator = _createForOfIteratorHelper(cookieList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _cookie = _step.value;

        var _ref3 = _cookie || {},
            _ref3$accepted = _ref3.accepted,
            accepted = _ref3$accepted === void 0 ? false : _ref3$accepted,
            groupid = _ref3.groupid,
            id = _ref3.id;

        var _codes = (0, _getCodesByID.default)(id, codes) || {};

        var _iterator2 = _createForOfIteratorHelper(_codes),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _code = _step2.value;

            var _ref4 = _code || {},
                area = _ref4.area,
                code = _ref4.code,
                codeID = _ref4.id,
                identifier = _ref4.identifier;

            if (accepted) {
              if (groupid !== 0 && groupid !== 4 && _trackingCodes.indexOf(codeID) === -1) {
                if (!code) continue; // Check if identifier is black listed, if it is execute code only on page load

                var isInBlackList = blackList.includes(identifier);

                if (!isInBlackList && code.indexOf("GTM-") > -1) {
                  (0, _log.default)({
                    message: "Error in tracking: identifier ".concat(identifier, " not found in blacklist - ").concat(blackList.join(", "))
                  });
                }

                if (isInBlackList) {
                  (0, _executeCode.default)({
                    id: codeID,
                    code: code,
                    area: area,
                    wrapper: false
                  });

                  _trackingCodes.push(codeID);
                } else {
                  (0, _executeCode.default)({
                    id: codeID,
                    code: code,
                    area: area
                  });
                }
              }
            } else {
              (0, _removeCode.default)(codeID);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    sessionStorage.setItem("mw-tracking-codes", _trackingCodes); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

var _default = ReactTracking;
exports.default = _default;